import axios from 'axios'

const BASE_URL = process.env.REACT_APP_API_URL
    ? `${process.env.REACT_APP_API_URL}/api/`
    : '/api/'

const api = _ => {
    const {token} = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : ''
    return axios.create({
        baseURL: BASE_URL,
        headers:{Authorization:`Bearer ${token}`}
    })
}

export default api